var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-title"},[_vm._t("default",[_vm._t("left",[_vm._v(_vm._s(_vm.title))]),_vm._t("right",[_vm._v(_vm._s(_vm.desc))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }